var scope_0 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/30e6d572a62ec4d4f202d4cb21b9b884.js').default;
var scope_1 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3bb2b7ee9ffa10a625af28b677b97293.js').default;
var scope_2 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b56b74855691a963c9bcfa88c7ccc56d.js').default;
var scope_3 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    